import { InputItemType } from './types';

export const SEARCH_MIN_LENGTH = 3;

export const ALL_CITIES: InputItemType = {
  city: 'Все города',
  cityId: 0,
};
